<template>
  <div class="cart-view">
    <div class="grid-row">
      <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
        <CartStepper />
      </div>
    </div>
    <div class="grid-row">
      <div class="c-12 c-xs-12 c-sm-12 c-md-12 c-lg-12">
        <h1>{{$_('my_cart')}} ({{getItemNumber}} {{getItemNumber > 1 ? 'articles' : 'article'}})</h1>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-9 c-xs-12 c-sm-12 c-md-12 c-lg-9">
        <CartProductList />
      </div>
      <div class="c-3 c-xs-12 c-sm-12 c-md-12 c-lg-3">
        <CartSummary :step="'cart'" :next_step="'cartdelivery'" />
      </div>
    </div>
  </div>
</template>

<script>

import CartProductList from '@/modules/panier/components/CartProductList';
import CartSummary from '@/modules/panier/components/CartSummary';
import CartStepper from '@/modules/panier/components/CartStepper';

export default {
  name: 'Cart',
  components: {
    CartProductList,
    CartSummary,
    CartStepper
  },
  data() {
    return {
      items_number: 0,
    }
  },
  computed: {
    getItemNumber() {
      return this.$store.getters['panier/get_cart'].length;
    }
  },
}
</script>

<style scoped>
.cart-view {
  padding: 15px;
}
</style>